module.exports = __webpack_public_path__ + "img/imgs2.6234d7ea.png";